import React, { useState } from 'react';
import styled, { CSSProp, css, FlattenSimpleInterpolation } from 'styled-components';
import { Link } from 'react-router-dom';
import HeaderLogo from '../../../svg/HeaderLogo.svg';
import footerLogo from '../../../img/Footer/footerLogo.png';
import { colors } from '../../../view/colors';
import { Footer } from '../../../view/Footer/Footer';

const HeaderBox = styled.nav`
  width: 100%;
  height: 244px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const HeaderText = styled(Link)`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-size: 20px;
  width: 150px;
  text-align: center;
  text-decoration: none;
  font-family: 'Roboto';
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;

const LogoLinkWrapper = styled(Link)`
  width: 150px;
`;

const StaticLink = styled.a`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-size: 20px;
  width: 150px;
  text-align: center;
  text-decoration: none;
  font-family: 'Roboto';
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;

const AbsoluteShopButtonWrapper = styled.div`
  position: absolute;
  right: 22px;
  top: 13px;
  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

const AbsoluteShopButton = styled.a`
  border-radius: 25px;
  font-size: 18px;
  line-height: 21px;
  height: 46px;
  box-sizing: border-box;
  padding: 0 35px;
  color: ${colors.twine};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-family: 'Roboto';
  cursor: pointer;
  background: white;
  text-decoration: none;

  span {
    padding-right: 15px;
    font-size: 20px;
  }
`;

const HeaderImg = styled.img`
  max-height: 150px;
`;

const DesktopNavbar = styled.span`
  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

const MobileMenu = styled.div`
  display: none;
  @media screen and (max-width: 1200px) {
    display: initial;
  }
`;

const MobileMenuButton = styled.button`
  position: absolute;
  right: 22px;
  top: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  height: 46px;
  width: 46px;
  border: none;
  color: ${colors.twine};
  z-index: 1;
`;

const MobileMenuInner = styled.div<{ isOpen: boolean }>`
  position: fixed;
  z-index: 1;
  opacity: 1;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: left 500ms ease, background-color 500ms;
  ${({ isOpen }): FlattenSimpleInterpolation | string => (isOpen
    ? css`
      left: 0;
      background: white;
    ` : '')}
`;

const MobileLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 25px;
`;

const FooterLogo = styled.div`
  height: 65px;
  width: 65px;
  margin-left: 20px;
  margin-top: 5px;
  background: url(${footerLogo});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

const MobileLink = styled(Link)`
  color: ${colors.twine};
  width: 100%;
  font-family: 'Roboto';
  line-height: 55px;
  font-size: 25px;
  font-style: normal;
  text-decoration: none;
`;

export function TopBarNavigation(): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <AbsoluteShopButtonWrapper>
        <AbsoluteShopButton href="https://www.sklep.owocowo.com.pl/">
          <span className="material-icons material-icons-outlined">
            shopping_cart
          </span>
          SKLEP
        </AbsoluteShopButton>
      </AbsoluteShopButtonWrapper>
      <DesktopNavbar>
        <HeaderBox>
          <HeaderText to="/">Strona główna</HeaderText>
          <HeaderText to="/aboutUs">O Nas</HeaderText>
          <HeaderText to="/ecology">Ekologia</HeaderText>
          <LogoLinkWrapper to="/">
            <HeaderImg alt="logo" src={HeaderLogo} />
          </LogoLinkWrapper>
          <HeaderText to="/contactUs">Kontakt</HeaderText>
          {/* <HeaderText to="/team">Zespół</HeaderText> */}
          <StaticLink href="https://www.sklep.owocowo.com.pl/">Sklep</StaticLink>
          <StaticLink href="http://www.blog.owocowo.com.pl/">Blog</StaticLink>
        </HeaderBox>
      </DesktopNavbar>
      <MobileMenu>
        <MobileMenuButton onClick={(): void => setIsOpen(!isOpen)} type="button">
          <span className="material-icons-outlined">
            menu
          </span>
        </MobileMenuButton>
        {isOpen && (
          <MobileMenuInner isOpen={isOpen}>
            <MobileMenuButton onClick={(): void => setIsOpen(!isOpen)} type="button">
              <span className="material-icons-outlined">
                close
              </span>
            </MobileMenuButton>
            <span>
              <FooterLogo />
              <MobileLinkWrapper>
                <MobileLink to="/">Strona główna</MobileLink>
                <MobileLink to="/aboutUs">O Nas</MobileLink>
                <MobileLink to="/contactUs">Kontakt</MobileLink>
                <MobileLink as="a" href="http://www.blog.owocowo.com.pl/">Blog</MobileLink>
                <MobileLink as="a" href="https://www.sklep.owocowo.com.pl/">Sklep</MobileLink>
              </MobileLinkWrapper>
            </span>
            <Footer />
          </MobileMenuInner>
        )}
        <HeaderBox>
          <LogoLinkWrapper to="/">
            <HeaderImg alt="logo" src={HeaderLogo} />
          </LogoLinkWrapper>
        </HeaderBox>
      </MobileMenu>
    </>
  );
}
